import axios from "axios";
import { urlBaseFiles } from "./config/index";
import axiosInstance from "../services/config/axiosinstance";

// Versão pública (sem JWT) — usada pela rota /template/:id.
// Endpoint dedicado que aceita upload sem token.
function getUrlFilesPublic(data) {
  const config = {
    method: "post",
    url: `${urlBaseFiles}/public/files`,
    headers: {
      "content-type": "multipart/form-data",
    },
    data,
  };
  return axios(config)
    .then((response) => response.data)
    .catch((error) => error?.response?.data);
}

function getUrlFiles(data, jwt) {
  var config = {
    method: "post",
    url: `${urlBaseFiles}/files`,
    headers: {
      "content-type": "multipart/form-data",
    },
    data: data,
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

// Mesmo endpoint de getUrlFiles, mas propaga o erro do axios em vez de devolver
// o corpo da resposta — quem chama precisa do status HTTP para diferenciar as
// falhas de upload (ex.: 413 quando o arquivo excede o limite do servidor).
function uploadFiles(data) {
  const config = {
    method: "post",
    url: `${urlBaseFiles}/files`,
    headers: {
      "content-type": "multipart/form-data",
    },
    data,
  };

  return axiosInstance(config).then((response) => response.data);
}

async function deleteFile(id, jwt) {
  var config = {
    method: "delete",
    url: `${urlBaseFiles}/files/${id}`,
    headers: {},
  };

  return axiosInstance(config)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export { getUrlFiles, getUrlFilesPublic, uploadFiles, deleteFile };
